module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousAir
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Airline Booking Order")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.BookingShippingLine.allModuleId ?
        this.BookingShippingLine.allModuleId :
        '',
      "jobSeriesBanner": this.BookingShippingLine.assignmentNumber ?
        this.BookingShippingLine.assignmentNumber :
        '',
      "bannerClientName": this.allShipperData[0].clientName ? this.allShipperData[0].clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "assignmentNumber",
      "id": "assignmentNumber",
      "disabled": ""
    },
    model: {
      value: (_vm.BookingShippingLine.assignmentNumber),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "assignmentNumber", $$v)
      },
      expression: "BookingShippingLine.assignmentNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', [_vm._v("IATA Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "list": _vm.agentMasterList,
      "placeholder": "Select IATA  Agent"
    },
    model: {
      value: (_vm.BookingShippingLine.IATAAgent),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "IATAAgent", $$v)
      },
      expression: "BookingShippingLine.IATAAgent"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.IATAAgent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.IATAAgent))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Booking Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "bookingDate",
      "name": "bookingDate"
    },
    model: {
      value: (_vm.BookingShippingLine.bookingDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "bookingDate", $$v)
      },
      expression: "BookingShippingLine.bookingDate"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.bookingDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.bookingDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Airline Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "airlineId",
      "custom-text": _vm.codeAndNameAndDesc1,
      "list": _vm.airMasterList,
      "placeholder": "Select Airline Name"
    },
    model: {
      value: (_vm.BookingShippingLine.airLine),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "airLine", $$v)
      },
      expression: "BookingShippingLine.airLine"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.airLine) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.airLine))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.BookingShippingLine.shipmentExecution) + "\n                "), _c('label', [_vm._v("MAWB No.(1234567890)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "MAWBNumber",
      "id": "MAWBNumber",
      "type": _vm.BookingShippingLine.shipmentExecution != 'Courier' ?
        'number' :
        'text'
    },
    on: {
      "keyup": function($event) {
        _vm.BookingShippingLine.shipmentExecution != 'Courier' ?
          _vm.containerNoRegexfun :
          ''
      }
    },
    model: {
      value: (_vm.BookingShippingLine.MAWBNumber),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "MAWBNumber", $$v)
      },
      expression: "BookingShippingLine.MAWBNumber"
    }
  })], 1), _vm._v(" "), (!_vm.BookingShippingLine.MAWBNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.mawbError))]) : (_vm.blRegexError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blRegexError))]) : _vm._e(), _vm._v(" "), (!_vm.BookingShippingLine.MAWBNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.MAWBNumber))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("MAWB Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "MAWBDate",
      "name": "MAWBDate"
    },
    model: {
      value: (_vm.BookingShippingLine.MAWBDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "MAWBDate", $$v)
      },
      expression: "BookingShippingLine.MAWBDate"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.MAWBDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.MAWBDate))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.airFreightModel.airFFType == 'fclNormal') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "clientName",
      "id": "clientName",
      "disabled": ""
    },
    model: {
      value: (_vm.BookingShippingLine.clientName),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "clientName", $$v)
      },
      expression: "BookingShippingLine.clientName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.clientList[0].typeAirway == 'HouseAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("HAWB No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "HAWBNumber",
      "id": "HAWBNumber"
    },
    model: {
      value: (_vm.BookingShippingLine.HAWBNumber),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "HAWBNumber", $$v)
      },
      expression: "BookingShippingLine.HAWBNumber"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.clientList[0].typeAirway == 'HouseAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("HAWB Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "HAWBDate",
      "name": "HAWBDate"
    },
    model: {
      value: (_vm.BookingShippingLine.HAWBDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "HAWBDate", $$v)
      },
      expression: "BookingShippingLine.HAWBDate"
    }
  })], 1) : _vm._e()], 1) : (_vm.clientList.length > 0 || _vm.hawbModal.moreHawbId != '') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [(_vm.hawbModal.moreHawbId == '') ? _c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Name")]) : _vm._e(), _vm._v(" "), (_vm.hawbModal.moreHawbId == '') ? _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "shipperFreightId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.hawbModal.shipperFreightId),
      callback: function($$v) {
        _vm.$set(_vm.hawbModal, "shipperFreightId", $$v)
      },
      expression: "hawbModal.shipperFreightId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.hawbModal.clientName),
      callback: function($$v) {
        _vm.$set(_vm.hawbModal, "clientName", $$v)
      },
      expression: "hawbModal.clientName"
    }
  })], 1), _vm._v(" "), (!_vm.hawbModal.shipperFreightId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHawbModal.shipperFreightId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("HAWB No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "HAWBNumber",
      "id": "HAWBNumber",
      "type": "number"
    },
    on: {
      "keyup": _vm.houseNoRegexfun
    },
    model: {
      value: (_vm.hawbModal.HAWBNumber),
      callback: function($$v) {
        _vm.$set(_vm.hawbModal, "HAWBNumber", $$v)
      },
      expression: "hawbModal.HAWBNumber"
    }
  })], 1), _vm._v(" "), (!_vm.hawbModal.HAWBNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHawbModal.HAWBNumber))]) : (_vm.houseRegexError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.houseRegexError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("HAWB Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "HAWBDate",
      "name": "HAWBDate"
    },
    model: {
      value: (_vm.hawbModal.HAWBDate),
      callback: function($$v) {
        _vm.$set(_vm.hawbModal, "HAWBDate", $$v)
      },
      expression: "hawbModal.HAWBDate"
    }
  }), _vm._v(" "), (!_vm.hawbModal.HAWBDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHawbModal.HAWBDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "1%"
    },
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "38px"
    },
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoaderhawb"
    },
    on: {
      "click": _vm.addHawbDetails
    }
  }, [_vm._v(_vm._s(_vm.hawbModal.moreHawbId == "" ? "Add HAWB" : "Edit HAWB"))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.HAWBArray.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("HAWB Details")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "tableHawb"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("HAWB No.")]), _vm._v(" "), _c('th', [_vm._v("HAWB Date")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.HAWBArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEdithawb(item)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(item.clientName) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.HAWBNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.HAWBDate)))])])
  }))])])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "Id"
    }
  }, [_vm._v("From Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "list": _vm.fromPortList,
      "placeholder": "Select Port Name"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'fromPortList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'fromPortList')
      }
    },
    model: {
      value: (_vm.BookingShippingLine.fromAirport),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "fromAirport", $$v)
      },
      expression: "BookingShippingLine.fromAirport"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.fromAirport) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.fromAirport))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("To Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "list": _vm.toPortList,
      "placeholder": "Select Port Name"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'toPortList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'toPortList')
      }
    },
    model: {
      value: (_vm.BookingShippingLine.toAirport),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "toAirport", $$v)
      },
      expression: "BookingShippingLine.toAirport"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.toAirport) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.toAirport))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Flight Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "flightNumber",
      "id": "flightNumber"
    },
    model: {
      value: (_vm.BookingShippingLine.flightNumber),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "flightNumber", $$v)
      },
      expression: "BookingShippingLine.flightNumber"
    }
  })], 1), _vm._v(" "), (!_vm.BookingShippingLine.flightNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.flightNumber))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Departure Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "dateDeparture",
      "name": "dateDeparture"
    },
    model: {
      value: (_vm.BookingShippingLine.dateDeparture),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "dateDeparture", $$v)
      },
      expression: "BookingShippingLine.dateDeparture"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.dateDeparture) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.dateDeparture))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Arrival Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "dateArrival",
      "name": "dateArrival"
    },
    model: {
      value: (_vm.BookingShippingLine.dateArrival),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "dateArrival", $$v)
      },
      expression: "BookingShippingLine.dateArrival"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.dateArrival) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.dateArrival))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "bookingShipment"
    }
  }, [_vm._v("Booking Transhipment")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "bookingShipmentVal",
      "option-text": "bookingShipmentText",
      "list": _vm.bookingShipmentList,
      "placeholder": "Select Booking Transhipment",
      "isDisabled": _vm.tentativeDetailArray.length == 0 ? false : true
    },
    model: {
      value: (_vm.BookingShippingLine.bookingShipment),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "bookingShipment", $$v)
      },
      expression: "BookingShippingLine.bookingShipment"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.bookingShipment) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.bookingShipment))]) : _vm._e(), _vm._v(" "), (
    _vm.BookingShippingLine.bookingShipment == 'yes' &&
    _vm.tentativeDetailArrayList.length == 0
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.bookingLengthError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [(
    _vm.BookingShippingLine.bookingShipment == 'yes' &&
    this.lastTransID == false
  ) ? _c('b-button', {
    attrs: {
      "variant": "outline-dark",
      "size": "sm"
    },
    on: {
      "click": _vm.showAddAirportmet
    }
  }, [_vm._v("Click here to\n                " + _vm._s(_vm.showAddAirport == false ? "Add " : "Hide") + " Transhipment")]) : _vm._e()], 1)], 1), _vm._v(" "), (
    _vm.BookingShippingLine.bookingShipment == 'yes' || _vm.showAddAirport == true
  ) ? _c('b-card', {
    staticClass: "gutr",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [(
    _vm.BookingShippingLine.bookingShipment == 'yes' && _vm.showAddAirport == true
  ) ? _c('div', {
    attrs: {
      "id": "TranshipmentDetail"
    }
  }, [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("From Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "list": _vm.fromPortListTrans,
      "placeholder": "Select Port Name"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'fromPortListTrans')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'fromPortListTrans')
      }
    },
    model: {
      value: (_vm.moreAirportModel.fromAirport),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "fromAirport", $$v)
      },
      expression: "moreAirportModel.fromAirport"
    }
  }), _vm._v(" "), (!_vm.moreAirportModel.fromAirport) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMoreAirport.fromAirport))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("To Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "list": _vm.toPortListTrans,
      "placeholder": "Select Port Name"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'toPortListTrans')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'toPortListTrans')
      }
    },
    model: {
      value: (_vm.moreAirportModel.toAirport),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "toAirport", $$v)
      },
      expression: "moreAirportModel.toAirport"
    }
  }), _vm._v(" "), (!_vm.moreAirportModel.toAirport) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMoreAirport.toAirport))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Flight Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "flightNumber",
      "id": "flightNumber"
    },
    model: {
      value: (_vm.moreAirportModel.flightNumber),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "flightNumber", $$v)
      },
      expression: "moreAirportModel.flightNumber"
    }
  })], 1), _vm._v(" "), (!_vm.moreAirportModel.flightNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMoreAirport.flightNumber))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Departure Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "dateDeparture",
      "name": "dateDeparture"
    },
    model: {
      value: (_vm.moreAirportModel.dateDeparture),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "dateDeparture", $$v)
      },
      expression: "moreAirportModel.dateDeparture"
    }
  }), _vm._v(" "), (!_vm.moreAirportModel.dateDeparture) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMoreAirport.dateDeparture))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Arrival Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "dateArrival1",
      "name": "dateArrival1"
    },
    model: {
      value: (_vm.moreAirportModel.dateArrival),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "dateArrival", $$v)
      },
      expression: "moreAirportModel.dateArrival"
    }
  }), _vm._v(" "), (!_vm.moreAirportModel.dateArrival) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMoreAirport.dateArrival))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "38px"
    },
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.addAirport
    }
  }, [_vm._v(_vm._s(_vm.moreAirportModel.moreAirportId == "" ? "Add" : "edit") + "\n                    Airport")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tentativeDetailArrayList.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v("Transhipment Details")])], 1), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "ffBookingTentative"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Flight No.")]), _vm._v(" "), _c('th', [_vm._v("From Location")]), _vm._v(" "), _c('th', [_vm._v("To Location")]), _vm._v(" "), _c('th', [_vm._v("Arrival Time")]), _vm._v(" "), _c('th', [_vm._v("Departure Time")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tentativeDetailArrayList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.flightNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fromAirportName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.toAirportName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.dateArrival)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.dateDeparture)))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewEdit(item, index)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.DeleteList(item, index)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1)])
  }))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.addBookingDetail
    }
  }, [_vm._v("Save & Proceed\n                To Execution")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20f65584","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airFreight/AirFreightBooking.vue
// module id = 2450
// module chunks = 0